<form #form="ngForm" novalidate (submit)="form.valid && onSubmit()">
  <div class="modal-header">
    <h4 class="h4 modal-title">
      <span i18n *ngIf="!dashboardId || hasDashboard">{{ title }} dashboard</span>
      <span i18n *ngIf="!!dashboardId && !hasDashboard">Loading...</span>
    </h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body add-dashboard-modal-body">
    <div class="form-group row">
      <label i18n for="name" class="default-label text-right col-form-label col-4">Dashboard name</label>
      <div [class.has-danger]="form.submitted && name.invalid" class="col">
        <input
          type="text"
          placeholder="Type name"
          i18n-placeholder="Type name"
          class="form-control"
          name="name"
          id="dashboard-name"
          required
          #name="ngModel"
          [(ngModel)]="model.name"
          ccFocus
        />
        <div class="sm-text-default-red" i18n *ngIf="form.submitted && name.invalid">name is required</div>
      </div>
    </div>
    <div class="form-group row">
      <div class="col-4"></div>
      <div class="col">
        <button type="submit" class="btn btn-success" [disabled]="!!dashboardId && !hasDashboard" i18n>
          {{ model.id ? 'Save' : 'Create' }}
        </button>
      </div>
    </div>
  </div>
</form>
